import { BottomNavigationAction as MUIBottomNavigationAction, styled } from '@mui/material'

const BottomNavigationAction = styled(MUIBottomNavigationAction)(() => ({}))

export default BottomNavigationAction
